// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import questionCitationEntity from './entities/question-citation.json';
import questionCitationMenu from '../pages/question-citation/menu.json';
import questionCitationFullForm from '../pages/question-citation/forms/full.json';
import questionCitationContextForm from '../pages/question-citation/forms/context.json';
import questionCitationMiniForm from '../pages/question-citation/forms/mini.json';
import questionCitationLookupForm from '../pages/question-citation/forms/lookup.json';
import questionCitationTableView from '../pages/question-citation/views/table.json';
import questionCitationCardsView from '../pages/question-citation/views/cards.json';
import questionCitationDashboardView from '../pages/question-citation/views/dashboard.json';

/** Тип запису «Посилання на джерело» зі сторінками пакета: меню, форми та подання з pages/question-citation/. */
export const questionCitationDefinition: IRecordTypeDefinition = {
  ...questionCitationEntity,
  views: assembleViewSet({
      table: questionCitationTableView,
      cards: questionCitationCardsView,
      dashboard: questionCitationDashboardView,
  }),
  form: questionCitationFullForm,
  forms: { full: questionCitationFullForm, context: questionCitationContextForm, mini: questionCitationMiniForm, lookup: questionCitationLookupForm },
  menu: questionCitationMenu,
} as IRecordTypeDefinition;
